import { Pipe, PipeTransform } from "@angular/core";
import { Assessment } from "src/app/core/models/assessment.model";

@Pipe({
  name: 'allAssessmentsCompleted',
  standalone: true
})
export class AllAssessmentsCompletedPipe implements PipeTransform {
  transform(assessments?: Assessment[]) {
    return assessments?.every(a => a.dateCompleted) ?? true;
  }
}
